import {Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy} from '@angular/core';
import {PaymentService} from "../../../service/payment.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {CreditCardValidator} from "ng2-cc-library";
import { Router } from '@angular/router';
import { BuildingsService } from '../../../service/buildings.service';
import { Subject } from 'rxjs';

declare var $: any;
declare var Stripe: any;
declare var Plaid: any;

const MONTHLY_PRICE = 40;

@Component({
  selector: 'app-payment-settings',
  templateUrl: './payment-settings.component.html',
  styleUrls: ['./payment-settings.component.css']
})
export class PaymentSettingsComponent implements OnInit, AfterViewInit, OnDestroy {

  addNewCardForm: FormGroup;

  // Get current loggedIn user ID
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userBuildingId = localStorage.getItem('userBuildingId');

  loading = false;
  loadInModal = false;

  // Payment Variables
  basicPaymentData;
  detailedPaymentData;
  paymentInstrumentdata = [];

  // Observables
  plaidPublicToken;
  plaidMetaData;
  metaData = new Subject();
  publicToken = new Subject();

  // Error Flags
  isCreditcardNumberInvalid = false;
  isCvcInvalid = false;
  isExpDateInvalid = false;
  isCardNameInvalid = false;
  isCardSaved  = false;
  isCardSaveError = false;
  isBankSaved = false;
  isBankSaveError = false;
  cardSubmit:boolean = false;

  buildings;
  finalBuilding;
  alert;
  // Data Binding vars
  @ViewChild('activeContent', { static: false })
  contentToChange: ElementRef;
  activeSet = 'credit';
  bankAccessTemp = false;
  constructor(private paymentService: PaymentService,
              private router: Router,
              private _fb: FormBuilder,
              private buildingService: BuildingsService,) { }

  ngOnInit() {
    this.addNewCardForm = this._fb.group({
      ccNumber: ['',[<any>CreditCardValidator.validateCCNumber, Validators.required]],
      ccName: ['',[Validators.required]],
      ccExpiry: ['',[Validators.required,<any>CreditCardValidator.validateExpDate]],
      cvvCode: ['',[<any>Validators.minLength(3),  <any>Validators.maxLength(4), Validators.required]],
    });

    // Get Stripe Customer List of Cards
    this.loading = true;
    this.paymentService.getCustomer(this.id).subscribe(
      (data) => {
        console.log('Customer : ',data);
        if(data) {
          this.basicPaymentData = data.customer;
          this.detailedPaymentData = data.customer.sources ? data.customer.sources.data : null;
          if(this.detailedPaymentData && this.detailedPaymentData.length > 0) {
            for(let paymentData of this.detailedPaymentData) {
              this.paymentInstrumentdata.push(paymentData);
            }
          }
          this.loading = false;
          console.log('Payment Instr data : ', this.paymentInstrumentdata);
        }
      }
    );

    $(window).ready(function () {
      $('.exp_label').click(function(){
        event.preventDefault();
      })
      $('#addpayment .page_sub_menu ul li').click(function () {
        $('.page_sub_menu ul li.active').removeClass('active');
        $(this).addClass('active');

      });
      $('#payment_settings .payment_modal .modal-header li').click(function () {
        $('#payment_settings .payment_modal .modal-header li.active').removeClass('active');
        $(this).addClass('active');

      });
      $('.wrap_drop h4 img').click(function () {
        $('#drop_down_payment').toggle();

      })
      $('.exp_datepicker').click(function(){
        $('.exp_datepicker').datepicker();
      })
    });


    // Check if publicToken and metaData values have changed due to Plaid object bank selection
    this.publicToken.subscribe(
      (publictoken) => {
        console.log(publictoken);
        this.plaidPublicToken = publictoken;
      }
    );
    this.metaData.subscribe(
      (metadata) => {
        console.log(metadata);
        this.plaidMetaData = metadata;
        this.loading = true;

        // Process NetBanking Payment
        this.paymentService.addBankAccount(this.plaidPublicToken, this.plaidMetaData.account_id, this.paymentInstrumentdata, this.basicPaymentData.id).subscribe(
          (data) => {
            console.log(data);
            if(data) {
              if(data.status) {
                this.isBankSaved = true;
                this.isBankSaveError = false;
                this.addNewCardForm.reset();
                setTimeout(() => {
                  this.isBankSaveError = false;
                  this.isBankSaved = false;
                  $('#addpayment .close').trigger('click');
                  // Get Stripe Customer List of Cards
                  this.loading = true;
                  this.paymentService.getCustomer(this.id).subscribe(
                    (data) => {
                      console.log('Customer : ',data);
                      if(data) {
                        this.basicPaymentData = data.customer;
                        this.detailedPaymentData = data.customer.sources.data;
                        if(this.detailedPaymentData.length > 0) {
                          this.paymentInstrumentdata = [];
                          for(let paymentData of this.detailedPaymentData) {
                            this.paymentInstrumentdata.push(paymentData);
                          }
                        }
                        this.loading = false;
                        console.log('Payment Instr data : ', this.paymentInstrumentdata);
                      }
                    }
                  );
                }, 2500);
              }else {
                this.isBankSaved = false;
                this.isBankSaveError = true;
              }
            }
            this.loading=false;
          }
        );
      }
    );


  }

  /**
   * Handler for add a new payment method
   * Form field values are submitted through Form Control declared in ngOnInit
   * Validates value - raises error if validation fails, passes on to the service layer if validation passes
   */
  addNewCard(){
    //console.log(this.addNewCardForm.value, this.addNewCardForm.valid);
    //$('#addpayment button.find_add_btn').attr('disabled', 'disabled');
    if(this.addNewCardForm.get('ccNumber').invalid){
      this.isCreditcardNumberInvalid = true;
    }else {
      this.isCreditcardNumberInvalid = false;
    }

    if(this.addNewCardForm.get('cvvCode').invalid || isNaN(this.addNewCardForm.get('cvvCode').value)){
      this.isCvcInvalid = true;
    }else {
      this.isCvcInvalid = false;
    }

    if(this.addNewCardForm.get('ccExpiry').invalid){
      this.isExpDateInvalid = true;
    }else {
      this.isExpDateInvalid = false;
    }

    if(this.addNewCardForm.get('ccName').invalid || this.addNewCardForm.value.ccName.trim().length <= 0){
      this.isCardNameInvalid = true;
    }else {
      this.isCardNameInvalid = false;
    }

    if(this.addNewCardForm.valid && !this.isCardNameInvalid && !this.isExpDateInvalid && !this.isCvcInvalid && !this.isCreditcardNumberInvalid) {
      this.cardSubmit = true;
      this.loadInModal = true;
      var ccObj = {
        object: 'card',
        exp_month: this.addNewCardForm.value.ccExpiry.split('/')[0],
        exp_year: this.addNewCardForm.value.ccExpiry.split('/')[1],
        number: this.addNewCardForm.value.ccNumber,
        currency: 'usd',
        name: this.addNewCardForm.value.ccName,
      };

      // Pass card values to service layer
      this.paymentService.saveNewCard(null, this.basicPaymentData.id, ccObj, this.detailedPaymentData).subscribe(
        (data) => {
           console.log('Creadit Card saved ? ', data);
           if(data) {

            if(data.status === false) {
              this.isCardSaveError = true;
              this.loadInModal = false;
              this.loading = false;
              this.isCardSaved = false;
              this.cardSubmit = false;
              //this.addNewCardForm.reset();
              //this.addNewCardForm.reset();
            }else if(data.status === true) {
              //this.addNewCardForm.reset();
              this.isCardSaveError = false;
              this.isCardSaved = true;
              this.loadInModal = false;

              setTimeout(() => {
                this.isCardSaved = false;
                this.isCardSaveError = false;
                $('#addpayment .close').trigger('click');
                this.cardSubmit = false;

                // Get Stripe Customer List of Cards
                this.loading = true;
                this.paymentService.getCustomer(this.id).subscribe(
                  (data) => {
                    console.log('Customer : ',data);
                    if(data) {
                      this.basicPaymentData = data.customer;
                      this.detailedPaymentData = data.customer.sources.data;
                      if(this.detailedPaymentData.length > 0) {
                        this.paymentInstrumentdata = [];
                        for(let paymentData of this.detailedPaymentData) {
                          this.paymentInstrumentdata.push(paymentData);
                        }
                      }
                      this.loading = false;
                      console.log('Payment Instr data : ', this.paymentInstrumentdata);
                    }else{
                      this.loading = false;
                    }
                  }
                );
              }, 2500);

            }else{
              this.cardSubmit = false;
            }

             //$('#addpayment button.find_add_btn').removeAttr('disabled');
          }else{
            this.cardSubmit = false;
            //$('#addpayment button.find_add_btn').removeAttr('disabled');
          }
        }, (err)=>{this.cardSubmit = false}
      );
    }else{
      //$('#addpayment button.find_add_btn').removeAttr('disabled');
    }

  }

  ngAfterViewInit() {
    var that = this;
    var start = new Date();
    start.setFullYear(start.getFullYear());
    var end = new Date();
    end.setFullYear(end.getFullYear() + 10);
    $("#expDate").datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      dateFormat: 'mm/yy',
      yearRange: start.getFullYear() + ':' + end.getFullYear(),
      onClose: function (dateText, inst) {
        $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
        that.addNewCardForm.controls['ccExpiry'].setValue($('#expDate').val());
      }
    });

    // On add new payment method modal close, reset form
    $('#addpayment').on('hidden.bs.modal', function () {
      that.addNewCardForm.reset();
      this.isCreditcardNumberInvalid = false;
      this.isCvcInvalid = false;
      this.isExpDateInvalid = false;
      this.isCardNameInvalid = false;
      this.isCardSaved  = false;
      this.isCardSaveError = false;
      this.isBankSaved = false;
      this.isBankSaveError = false;
      $('input#cc_number').removeClass('error');
      $('input#cvv_code').removeClass('error');
      $('input#cc_number').removeClass('error');
      $('input#cc_number').removeClass('error');
    });

    this.buildingService.getAllBuildingsByUserId(this.id).subscribe(
      (buildings) => {
        console.log(buildings.data[0].building);
        if(buildings.success){
          this.buildings = buildings.data[0].building;
        }
      }
    );

  }

  ngOnDestroy(){
    $('#addpayment .close').trigger('click');
    $('#upgradeModal .close').trigger('click');
    this.resetVal();
  }

  activeClassChange(type){
    this.activeSet = type;
    if(type == 'credit'){
      $('.credit_content').css('display','block');
      $('.bank_content').css('display', 'none');
    }
    else {
      $('.credit_content').css('display', 'none');
      $('.bank_content').css('display', 'block');
    }
  }

  updateMaxlen(ccNum){
    console.log(ccNum);
  }

  /**
   * Replace existing payment method with bank account information
   */
  onPlaidButtonClick() {

    const localToken = this.publicToken;
    const localMetaData = this.metaData;
    let publicTokenLocal = '';
    let metaDataLocal = '';

    const plaid = Plaid.create({
      env: 'sandbox',
      clientName: 'Mycoop',
      key: '674ba7c50122abd83b5900f21250cf',
      product: ['auth'],
      selectAccount: true,
      onSuccess: function (public_token, metadata) {
        console.log('success');
        // Send the public_token and account ID to your app server.
        console.log('public_token: ' + public_token);
        console.log(metadata);
        publicTokenLocal = public_token;
        metaDataLocal = metadata;
        localToken.next(publicTokenLocal);
        localMetaData.next(metaDataLocal);
      },
      onExit: function (err, metadata) {
        // The user exited the Link flow.
        if (err != null) {
          console.log('error');
          console.log(err);
          // The user encountered a Plaid API error prior to exiting.
        } else {
          console.log(metadata);
        }
      },
    });

    plaid.open('ins_109509');
  }

  /**
   * Reset all form values, css classes and flags
   */
  resetVal(){
    this.addNewCardForm ? this.addNewCardForm.reset() : '';
    this.isCreditcardNumberInvalid = false;
    this.isCvcInvalid = false;
    this.isExpDateInvalid = false;
    this.isCardNameInvalid = false;
    this.isCardSaved  = false;
    this.isCardSaveError = false;
    this.isBankSaved = false;
    this.isBankSaveError = false;
    $('input#cc_number').removeClass('error');
    $('input#cvv_code').removeClass('error');
    $('input#cc_number').removeClass('error');
    $('input#cc_number').removeClass('error');
  }
  setTimePicker(){
    var that = this;
    var start = new Date();
    start.setFullYear(start.getFullYear());
    var end = new Date();
    end.setFullYear(end.getFullYear() + 10);
    $("#expDate").datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      dateFormat: 'mm/yy',
      yearRange: start.getFullYear() + ':' + end.getFullYear(),
      onClose: function (dateText, inst) {
        $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
        that.addNewCardForm.controls['ccExpiry'].setValue($('#expDate').val());
      }
    });
  }

  showAllBuildings(){
    $('#all_building_drp').toggle();
  }

  accountDowngrade(){

    console.log(this.buildings)
    if(this.buildings.length > 1){
      $('#upgradeModal').modal('show');
    }else{
      this.loading = true;
      this.accountDowngradeConfirmation(this.buildings[0].id);
    }
  }

  accountDowngradeConfirmation(buildingId=null){

    this.paymentService.accountDowngrade(this.id, buildingId).subscribe((data)=>{
      console.log(data, "ddddd-d-d--d-d-d-ddd-")
      if(data.success){
        this.loading = false;
        localStorage.setItem('type', 'resident')
        localStorage.setItem('isManager', 'false')
        localStorage.setItem('userBuildingId', data.buildingIds.toString());
        window.location.href = '/upgradesuccess/?type=false';
      }
    })
  }

  selectedBuilding(build){
    this.alert = null;
    this.finalBuilding = build;
  }

  accountDowngradeCancel(){
    this.finalBuilding = null;
    $('#upgradeModal').modal('hide');
  }

  accountDowngradeHandler(){

    if(!this.finalBuilding){
      this.alert = "Please select your current residence";

      return;
    }

      this.loading = true;
      const buildingId = this.finalBuilding.id;
      this.accountDowngradeConfirmation(buildingId)
  }

}
